import { Body, Controller, Post } from '@nestjs/common';
import { returnException } from '@project-management-system/backend-utils';
import { CommonResponseModel, GlobalResponseObject } from '@project-management-system/shared-models';
import { SendOptions } from './dtos/send-mail.dto';
import { GSuiteMailerService } from './g-sute-mailer.service';

@Controller('mailer')
export class MailerController {
    constructor(private readonly service: GSuiteMailerService) { }

    @Post('sendGSuiteMail')
    async sendGSuiteMail(@Body() req: SendOptions): Promise<CommonResponseModel> {
        try {
            return await this.service.sendGSuiteMail(req);
        } catch (error) {
            console.log(error)
            return returnException(GlobalResponseObject, error);
        }
    }
}
